// Slim CBAR bundle for layout.phtml (homepage, payment, billing).
// When adding <cbar-*> to those views: import the package here, then yarn build.
// See AGENTS.md section "Public layout web components".
import '@cbar/cbar-theme-cbar';
import '@cbar/cbar-theme/cbar-theme.js';

import '@cbar/cbar-entity-select';
import '@cbar/cbar-select/cbar-select.js';
import '@cbar/cbar-multi-select-combo-box';

import '@cbar/cbar-country-autocomplete';

const CbarCountryAutocomplete = customElements.get('cbar-country-autocomplete');
if (CbarCountryAutocomplete && !CbarCountryAutocomplete.__cbarFormValuePatched) {
  CbarCountryAutocomplete.__cbarFormValuePatched = true;

  const syncCountryFormValue = function () {
    if (this.name && this._internals) {
      this._internals.setFormValue(this.country || null);
    }
  };

  const origConnectedCallback = CbarCountryAutocomplete.prototype.connectedCallback;
  CbarCountryAutocomplete.prototype.connectedCallback = function () {
    origConnectedCallback.call(this);
    this.addEventListener('country-changed', syncCountryFormValue);
    this.addEventListener('selected', syncCountryFormValue);
    syncCountryFormValue.call(this);
  };

  const origUpdated = CbarCountryAutocomplete.prototype.updated;
  CbarCountryAutocomplete.prototype.updated = function (changedProperties) {
    origUpdated.call(this, changedProperties);
    if (changedProperties.has('country')) {
      syncCountryFormValue.call(this);
    }
  };
}

const CbarSelect = customElements.get('cbar-select');
if (CbarSelect && !CbarSelect.__cbarFormValuePatched) {
  CbarSelect.__cbarFormValuePatched = true;
  const origFormResetCallback = CbarSelect.prototype.formResetCallback;
  CbarSelect.prototype.formResetCallback = function () {
    origFormResetCallback.call(this);
    if (this.name && this._internals) {
      this._internals.setFormValue(this.value || null);
    }
  };
  const origOnChange = CbarSelect.prototype.onChange;
  CbarSelect.prototype.onChange = function (e) {
    origOnChange.call(this, e);
    if (this.name && this._internals) {
      this._internals.setFormValue(this.value || null);
    }
  };
}

// Ensure form-associated selects submit programmatic value changes.
const CbarEntitySelect = customElements.get('cbar-entity-select');
if (CbarEntitySelect && !CbarEntitySelect.__cbarFormValuePatched) {
  CbarEntitySelect.__cbarFormValuePatched = true;
  const origHandleUpdatedValue = CbarEntitySelect.prototype.handleUpdatedValue;
  CbarEntitySelect.prototype.handleUpdatedValue = function () {
    origHandleUpdatedValue.call(this);
    if (this.name && this._internals) {
      if (this.value) {
        const fd = new FormData();
        fd.append(this.name, this.value);
        this._internals.setFormValue(fd);
      } else {
        this._internals.setFormValue(null);
      }
    }
  };
}

import '@cbar/cbar-circular-progress/cbar-circular-progress.js';
import '@cbar/cbar-card';
import '@cbar/cbar-input/cbar-input.js';
import '@cbar/cbar-form-grid/cbar-form-grid.js';
import '@cbar/cbar-button/cbar-button.js';
import '@cbar/cbar-entity-card/cbar-entity-card.js';
import '@cbar/cbar-entity-title';
import '@cbar/cbar-campaigns-page';
import '@cbar/cbar-checkbox/cbar-checkbox.js';
import '@cbar/cbar-radio/cbar-radio.js';
import '@cbar/cbar-app-logout';
import '@cbar/cbar-address-format';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
